import { useMutation } from "react-query";
import { axiosDefaultApi } from "src/lib/axios";
import { MutationConfig, queryClient } from "src/lib/react-query";
import useNotification from "src/store/Notifications/useNotification";


const deleteEstablishment = ({ establishmentId }: { establishmentId: number }): Promise<string> => {
  return axiosDefaultApi.delete(`/api/Establishments/DeleteEstablishment/${establishmentId}`);
};

type QueryFnType = typeof deleteEstablishment;

type UseDeleteEstablishmentOptions = {
  establishmentId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useDeleteEstablishment = ({ config }: UseDeleteEstablishmentOptions) => {
  const { addNotification, setIsNotificationVisible } = useNotification();
  return useMutation({
    onError: (error: any) => {
      addNotification(`Υπήρξε κάποιο πρόβλημα στην διαγραφή του Καταστήματος.`, 500);
      console.error("Couldnt delete Establishment", error);
      setIsNotificationVisible(true);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["getAllEstablishments"]);
      addNotification(`Το Κατάστημα Διαγράφηκε.`, 200);
      setIsNotificationVisible(true);
    },
    ...config,
    mutationFn: deleteEstablishment,
  });
};
